import React from 'react'
import { observer,inject } from 'mobx-react'

import classNames from 'classnames'
import PropTypes from 'prop-types';
import { withStyles,withTheme } from 'material-ui/styles'
import Paper from 'material-ui/Paper'
import Typography from 'material-ui/Typography'
import T from 'i18n-react'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'


@inject('store','ui') @observer
class CartItemCount extends React.Component {
  render () {
    const cart = this.props.store.cart, ui = this.props.ui.cart, { classes, showInCart } = this.props
    let styles = classes.paperContainer

    if (showInCart) {
      styles = `${classes.paperContainer} ${classes.showInCart}`
    }

    return (
      cart.hasItems &&
       <Paper elevation={4} className={styles} onClick={ui.toggleCart}>
        <Typography className={classes.selectedText}>
         <span className={classes.count}> {cart.items.length} </span> {T.translate("cart.selected")}
        </Typography>
        <IconButton color="inherit" className={classes.spacing}>
         <Icon>{ui.open ? "keyboard_arrow_down" : "keyboard_arrow_up"}</Icon>
        </IconButton>
       </Paper>
    )
  }
}



const styles = theme => ({
 showInCart: {
   left:"0px !important",
   top:"0px !important",
   height:"60px !important"
 },
 selectedText:{
   color:'#fff',
   padding:20,
   flex: 1
 },
 count:{
  color:'#ff6e40'
 },
 paperContainer: {
  left:'unset',
  width: '100vw',
  right: 0,
  bottom: 0,
  flex: "1 0 auto",
  height: "auto",
  display: "flex",
  zIndex: 1300,
  position: "fixed",
  overflowY: "auto",
  willChange: "transform",
  flexDirection: "row",
  webkitOverflowScrolling: "touch",
  background:'#222',
  color:"#fff",
  cursor:"pointer",
  [theme.breakpoints.up('md')]: {
    width: '50vw',
    marginRight:'10%',
  },
 },
 spacing:{
   marginTop:3
 }
})

CartItemCount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(CartItemCount)



// WEBPACK FOOTER //
// ./src/components/cartitemcount.js